import { createGlobalConfig, panoramaClientFactory, PanoramaPlatform } from '@wix/panorama-client-web'

const globalConfig = createGlobalConfig()

const panoramaFactory = panoramaClientFactory({
  baseParams: {
    platform: PanoramaPlatform.Standalone,
    fullArtifactId: 'com.wixpress.funnel-intro-viewer',
    artifactVersion: window.__ARTIFACT_VERSION__,
    componentId: 'funnel-intro-viewer',
    uuid: window.__USER_ID__,
  },
  pluginParams: {
    sentry: window.Sentry,
    sentryDsn: window.__SENTRY_DSN__,
    sentryMain: true,
  },
}).withGlobalConfig(globalConfig)

export const panoramaClient = panoramaFactory.client()
